// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-modal {
  background: #fff;
  padding: 24px 30px;
  border-radius: 14px;
  width: 320px;
  text-align: center;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease;
}
.delete-modal h3 {
  margin-bottom: 12px;
  color: #dc2626;
  font-weight: 600;
}
.delete-modal p {
  font-size: 15px;
  color: #444;
}
.delete-modal .delete-warning {
  font-size: 13px;
  color: #dc2626;
  margin-top: 6px;
}

.delete-modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.delete-modal-actions .confirm-btn,
.delete-modal-actions .cancel-btn {
  flex: 1 1;
  padding: 10px;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 5px;
  transition: 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.delete-modal-actions .confirm-btn:disabled,
.delete-modal-actions .cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.delete-modal-actions .confirm-btn {
  background-color: #ef4444;
  color: white;
}
.delete-modal-actions .confirm-btn:hover:not(:disabled) {
  background-color: #dc2626;
}
.delete-modal-actions .confirm-btn.deleting {
  background-color: #dc2626;
}
.delete-modal-actions .confirm-btn.deleting .spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.delete-modal-actions .cancel-btn {
  background-color: #e5e7eb;
  color: #333;
}
.delete-modal-actions .cancel-btn:hover:not(:disabled) {
  background-color: #d1d5db;
}
.delete-modal-actions .cancel-btn:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DeleteConfirmationModal/DeleteConfirmationModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,2BAAA;AACF;AACE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,WAAA;AAAJ;AAGE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AADJ;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AAFF;AAIE;;EAEE,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAFJ;AAII;;EACE,mBAAA;EACA,YAAA;AADN;AAKE;EACE,yBAAA;EACA,YAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;AAMI;EACE,yBAAA;AAJN;AAMM;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,2BAAA;EACA,kBAAA;EACA,kCAAA;AAJR;AASE;EACE,yBAAA;EACA,WAAA;AAPJ;AASI;EACE,yBAAA;AAPN;AAUI;EACE,yBAAA;EACA,cAAA;AARN;;AAaA;EACE;IAAK,uBAAA;EATL;EAUA;IAAO,yBAAA;EAPP;AACF;AASA;EACE;IACE,UAAA;IACA,qBAAA;EAPF;EASA;IACE,UAAA;IACA,mBAAA;EAPF;AACF","sourcesContent":[".delete-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  background: rgba(0, 0, 0, 0.45);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.delete-modal {\r\n  background: #fff;\r\n  padding: 24px 30px;\r\n  border-radius: 14px;\r\n  width: 320px;\r\n  text-align: center;\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);\r\n  animation: fadeIn 0.3s ease;\r\n\r\n  h3 {\r\n    margin-bottom: 12px;\r\n    color: #dc2626;\r\n    font-weight: 600;\r\n  }\r\n\r\n  p {\r\n    font-size: 15px;\r\n    color: #444;\r\n  }\r\n\r\n  .delete-warning {\r\n    font-size: 13px;\r\n    color: #dc2626;\r\n    margin-top: 6px;\r\n  }\r\n}\r\n\r\n.delete-modal-actions {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n  .confirm-btn,\r\n  .cancel-btn {\r\n    flex: 1;\r\n    padding: 10px;\r\n    font-size: 14px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    margin: 0 5px;\r\n    transition: 0.2s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n\r\n    &:disabled {\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n\r\n  .confirm-btn {\r\n    background-color: #ef4444;\r\n    color: white;\r\n\r\n    &:hover:not(:disabled) {\r\n      background-color: #dc2626;\r\n    }\r\n\r\n    &.deleting {\r\n      background-color: #dc2626;\r\n      \r\n      .spinner {\r\n        width: 16px;\r\n        height: 16px;\r\n        border: 2px solid rgba(255, 255, 255, 0.3);\r\n        border-top: 2px solid white;\r\n        border-radius: 50%;\r\n        animation: spin 1s linear infinite;\r\n      }\r\n    }\r\n  }\r\n\r\n  .cancel-btn {\r\n    background-color: #e5e7eb;\r\n    color: #333;\r\n\r\n    &:hover:not(:disabled) {\r\n      background-color: #d1d5db;\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: #f3f4f6;\r\n      color: #9ca3af;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
